export default __webpack_public_path__ + "static/media/1910.749b7db7.png";